const state = {
  // 首页tips
  openLits: [
    // {
    //   name: '首页',
    //   selected: true,
    //   url: 'home'
    // }
  ],
  // 规划咨询模块弹出
  proposalLayer: true,
  studyLayer: true,
  planLayer: true,
  // 投资管理弹出
  touziLayer: true,
  // 是否项目组成员
  ayth: '',
  // 默认菜单列表选中的菜单
  urlItem:  sessionStorage.getItem('urlItem')?JSON.parse(sessionStorage.getItem('urlItem')):{
    name:'施工许可项目',
    path:'/main/ProjectJD',
    index:'0'
  },
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js